var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "history", style: { minHeight: "50px" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("history")))]),
      _c("w-scroll-view", { attrs: { tag: "w-card-content" } }, [
        _c(
          "ul",
          { staticClass: "timeline" },
          [
            _vm._l(_vm.historyItems, function (item) {
              return _c("app-sale-history-event", {
                key: item.key,
                attrs: { event: item },
                on: {
                  "open-info": function ($event) {
                    _vm.openedExtraInfoEvent = item
                  },
                },
              })
            }),
            _c("li", { staticClass: "green" }, [
              _c("div", { staticClass: "event" }, [
                _vm._v(" " + _vm._s(_vm.$ct("created")) + " "),
              ]),
              _c("div", { staticClass: "props" }, [
                _vm._v(" " + _vm._s(_vm.creatorName) + " "),
              ]),
              _vm.sale.CreatorNfcTag
                ? _c("div", { staticClass: "props nfc-tag" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$ct("with-nfc-tag", {
                            nfcTag: _vm.sale.CreatorNfcTag,
                          })
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "date" }, [
                _vm._v(" " + _vm._s(_vm.createdDateString) + " "),
              ]),
            ]),
          ],
          2
        ),
      ]),
      _vm.openedExtraInfoEvent
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "900" } },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.openedExtraInfoEvent.getEventString()) +
                          " "
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.openedExtraInfoEvent = null
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(_vm.extraInfoComponentName, {
                    tag: "component",
                    attrs: { event: _vm.openedExtraInfoEvent, sale: _vm.sale },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }